"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateViewFromQuery = void 0;
const backwardCompatQuery_1 = require("@opsbase/lib-data-query/helpers/backwardCompatQuery");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const View_1 = __importDefault(require("../View"));
function generateViewFromQuery(query) {
    var _a, _b;
    const view = new View_1.default();
    (0, backwardCompatQuery_1.backwardCompatQuery)(query);
    Object.assign(view, query);
    if ((_a = view.highlightedDateRange) === null || _a === void 0 ? void 0 : _a.from)
        view.highlightedDateRange.from = (0, moment_timezone_1.default)(view.highlightedDateRange.from);
    if ((_b = view.highlightedDateRange) === null || _b === void 0 ? void 0 : _b.to)
        view.highlightedDateRange.to = (0, moment_timezone_1.default)(view.highlightedDateRange.to);
    return view;
}
exports.generateViewFromQuery = generateViewFromQuery;
exports.default = generateViewFromQuery;
